import ar from './locale/ar';
import bg from './locale/bg';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
// Altipal: los textos que upstream dejo en ingles, MAS la terminologia propia
// de la Mesa. Van en un archivo APARTE y se mezclan en profundidad sobre el
// espanol: editar los JSON de upstream haria que cada upgrade de Chatwoot
// rompiera este parche (esos archivos cambian en casi cada release). Asi el
// unico archivo que tocamos es el nuestro, y nadie mas lo va a mover.
import esAltipal from './locale/es-altipal.json';
import et from './locale/et';
import fa from './locale/fa';
import fi from './locale/fi';
import fr from './locale/fr';
import he from './locale/he';
import hi from './locale/hi';
import hu from './locale/hu';
import id from './locale/id';
import it from './locale/it';
import ja from './locale/ja';
import ko from './locale/ko';
import lv from './locale/lv';
import ml from './locale/ml';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sl from './locale/sl';
import sr from './locale/sr';
import sv from './locale/sv';
import ta from './locale/ta';
import th from './locale/th';
import tr from './locale/tr';
import uk from './locale/uk';
import uz from './locale/uz';
import vi from './locale/vi';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';
import is from './locale/is';
import lt from './locale/lt';

/**
 * Mezcla profunda: `{...es, ...esAltipal}` no sirve porque las claves son
 * anidadas (CONVERSATION.FOOTER.X) y el spread superficial reemplazaria la rama
 * completa, perdiendo todo lo que upstream ya tiene traducido.
 */
const fusionar = (base, encima) =>
  Object.entries(encima).reduce(
    (acc, [clave, valor]) => ({
      ...acc,
      [clave]:
        valor && typeof valor === 'object' && !Array.isArray(valor)
          ? fusionar(acc[clave] || {}, valor)
          : valor,
    }),
    { ...base }
  );

export default {
  ar,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es: fusionar(es, esAltipal),
  et,
  fa,
  fi,
  fr,
  he,
  hi,
  hu,
  id,
  it,
  ja,
  ko,
  ml,
  lv,
  nl,
  no,
  pl,
  pt_BR,
  pt,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  ta,
  th,
  tr,
  uk,
  uz,
  vi,
  zh_CN,
  zh_TW,
  is,
  lt,
};
